import { nsMerchantUser } from '@/app/i18n/namespaces';

const MERCHANT_USER_PROFILES = {
    PROFILE_STANDARD: { name: 'PROFILE_STANDARD', entity: 'profile.PROFILE_STANDARD', namespace: nsMerchantUser },
    PROFILE_ADMIN_MERCHANT_MAIN: { name: 'PROFILE_ADMIN_MERCHANT_main', entity: 'profile.PROFILE_ADMIN_MERCHANT_main', namespace: nsMerchantUser },
    PROFILE_STANDARD_MAIN: { name: 'PROFILE_STANDARD_main', entity: 'profile.PROFILE_STANDARD_main', namespace: nsMerchantUser },
    PROFILE_ADMIN_MERCHANT: { name: 'PROFILE_ADMIN_MERCHANT', entity: 'profile.PROFILE_ADMIN_MERCHANT', namespace: nsMerchantUser }
};

export default MERCHANT_USER_PROFILES;